import {
  ICard,
  ICardWrapper,
  IParentPage,
  ITabWrapper,
} from '../../../types/shared';

import { ParsedResults, WizardItem } from '../../../types/wizard';

export interface WizardResultLayoutProps {
  name: string;
  header: ICard;
  body: (ICard | ICardWrapper | ITabWrapper)[];
  results: ParsedResults;
  queryTags: string;
  noResultCards: ICard[];
  showResultTitles: boolean;
  enableCustomResultMail: boolean;
  onResetButtonClick: () => void;
  wizardName: string;
  wizardSlug: string;
  wizardParentPage?: IParentPage;
  hasIframe?: boolean;
  className?: string;
}

// eslint-disable-next-line no-shadow
export enum WizardResultBodyItemName {
  CARD = 'card',
  CARD_WRAPPER = 'card-wrapper',
  TAB_WRAPPER = 'tab-wrapper',
}

interface CardExtended extends ICard {
  name: WizardResultBodyItemName;
}

interface CardWrapperExtended extends ICardWrapper {
  name: WizardResultBodyItemName;
}

export interface TabWrapperExtended extends ITabWrapper {
  name: WizardResultBodyItemName;
}

export type WizardBodyItem =
  | CardExtended
  | CardWrapperExtended
  | TabWrapperExtended;

export interface GroupedWizardItem {
  id: string;
  title: string;
  items: WizardItem[];
}

export interface WizardResult {
  title: string;
  role: string;
}

export interface WizardItemResult {
  title: string;
  results: WizardResult[];
}
